import { render, staticRenderFns } from "./StatementPane.vue?vue&type=template&id=5e74e330&scoped=true"
import script from "./StatementPane.vue?vue&type=script&lang=js"
export * from "./StatementPane.vue?vue&type=script&lang=js"
import style0 from "./StatementPane.vue?vue&type=style&index=0&id=5e74e330&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e74e330",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e74e330')) {
      api.createRecord('5e74e330', component.options)
    } else {
      api.reload('5e74e330', component.options)
    }
    module.hot.accept("./StatementPane.vue?vue&type=template&id=5e74e330&scoped=true", function () {
      api.rerender('5e74e330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/influencer_panel/components/StatementPane.vue"
export default component.exports